import { graphql, useFragment } from 'react-relay';
import PropTypes from 'prop-types';
import {
    FILTER_STATS_PRICE,
    FILTER_STATS_PRICE_TRADE,
    getFilterValues,
    getAppliedFilter,
} from '../sbSharedRefineMenuHelpers.ts';

/* Components */
import { SbSharedRefineMenuRadioSelect } from '../../SbSharedRefineMenu/SbSharedRefineMenuRadioSelect/SbSharedRefineMenuRadioSelect.jsx';

import styles from './SbSharedRefineMenuPriceRanges.scss';

const itemSearchFragment = graphql`
    fragment SbSharedRefineMenuPriceRanges_itemSearch on ItemSearchQueryConnection {
        displayUriRef
        appliedFilters {
            name
            canBeDismissed
            values {
                urlLabel
                linkReference
            }
        }
        filters {
            name
            values {
                linkReference
                linkable
                displayName
                urlLabel
                currency
            }
        }
    }
`;
const userFragment = graphql`
    fragment SbSharedRefineMenuPriceRanges_user on User {
        isVerifiedTrade
    }
`;

export const SbSharedRefineMenuPriceRanges = ({
    itemSearch: itemSearchRef,
    user: userRef,
    currency,
    trackingOptions,
}) => {
    const itemSearch = useFragment(itemSearchFragment, itemSearchRef);
    const user = useFragment(userFragment, userRef);
    const { displayUriRef = '', appliedFilters = [], filters = [] } = itemSearch;
    const isTradeUser = user?.isVerifiedTrade;
    const filterName = isTradeUser ? FILTER_STATS_PRICE_TRADE : FILTER_STATS_PRICE;
    const appliedFilterValues = getFilterValues(appliedFilters, filterName);
    const appliedFilter = getAppliedFilter(appliedFilters, filterName);
    const priceFilterValues = getFilterValues(filters, filterName);
    const valuesToShow = priceFilterValues.filter(filter => filter.currency === currency) || [];
    const canBeDismissed = appliedFilter ? appliedFilter.canBeDismissed : true;

    return (
        <div className={styles.wrapper}>
            <SbSharedRefineMenuRadioSelect
                filterName={filterName}
                valuesToShow={valuesToShow}
                displayUriRef={displayUriRef}
                canBeDismissed={canBeDismissed}
                appliedFilterValues={appliedFilterValues}
                currency={currency}
                trackInputIndex
                trackingOptions={trackingOptions}
            />
        </div>
    );
};

SbSharedRefineMenuPriceRanges.propTypes = {
    user: PropTypes.object,
    itemSearch: PropTypes.object.isRequired,
    currency: PropTypes.string.isRequired,
    trackingOptions: PropTypes.object,
};
